import { render, staticRenderFns } from "./NavbarElement.vue?vue&type=template&id=1fcf49aa&scoped=true&"
import script from "./NavbarElement.vue?vue&type=script&lang=ts&"
export * from "./NavbarElement.vue?vue&type=script&lang=ts&"
import style0 from "./NavbarElement.vue?vue&type=style&index=0&id=1fcf49aa&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fcf49aa",
  null
  
)

export default component.exports